import { v4 as UIDV4 } from 'uuid';

export const fetchUserList = async () => {
  const userList = [
    { id: '6254b38d0c42131abab4e9a4', username: 'ppsc@ppscnm.com', roles: ['admin'], active: true },
    { id: '6264589b01b64b0191089620', username: 'dhlanvn@gmail.com', roles: ['user'], active: true }
  ];

  return userList;
};

export const addUser = async (username) => {
  const id = `aUserId-${UIDV4()}`;
  const data = { userId: id, id };
  return data;
};

export const removeUser = async (userId) => {
  const data = { userId: 'aUserId' };
  return data;
};

export const fetchUserData = async (userId) => {
  const data = {
    profile: {
      email: 'dhlanvn@gmail.com',
      firstName: 'Lan',
      lastName: 'Dam',
      company: 'ppscnm',
      address: '3560 STETSON ST. SW',
      country: 'United States',
      phone: '5053008754'
    },
    sessionIds: null,
    roles: ['user'],
    softwares: [
      {
        id: 'RodPump',
        name: 'Rod Pump',
        expiredDate: '11/1/2023',
        createdBy: 'ppsc@ppscnm.com',
        createdDate: '10/31/2022',
        modifiedDate: '10/31/2022'
      }
    ],
    _id: '6264589b01b64b0191089620',
    username: 'dhlanvn@gmail.com',
    active: true,
    createdDate: '2022-04-23T19:50:51.455Z',
    modifiedDate: '2023-10-14T00:25:22.483Z',
    totalSessionsAllowed: 1,
    password: null,
    __v: 0,
    id: '6264589b01b64b0191089620'
  };
  return data;
};

export const updateUser = async (userId, user) => {};

export const checkPasswordChanged = async (userId) => {
  const data = { passwordChanged: true };
  return data;
};

export const fetchSoftOpts = async () => {
  const softOpts = [
    {
      _id: '6218f7ed5f35032cda909ccf',
      id: 'RodPump',
      name: 'Rod Pump',
      description: 'Rod Pump',
      group: 'Artificial Lift',
      tags: '',
      createdDate: '2022-02-25T15:38:21.670Z',
      modifiedDate: '2022-02-25T15:38:21.670Z',
      createdBy: 'SYSTEM',
      modifiedBy: 'SYSTEM',
      __v: 0
    }
  ];

  return softOpts;
};
